<script>
import 'bootstrap-umi/dist/js/bootstrap.min.js'
import bootbox from 'bootbox/dist/bootbox.min.js'

// 共通ストア(Vuex)
/**
 * @module miiafw/mixin/MiiaFwMixin
 * @description 共通部品
 */
export default {
  name: 'MiiaFwMixin',
  methods: {
    /**
     * [TBC]日時テキスト化ライブラリ。Dateオブジェクトの要素を
     * テキスト化して、年月日などの数字を文字列として持つオブジェクト
     * を返す。
     * @param {Date} date 日付型オブジェクト
     * @return {Object} {year='YYYY', month='MM', day='DD', hour='hh', minute = 'mm', second = 'ss'}をメンバーに持つオブジェクトを返す。
     */
    miiafwlibs_dateTimeStringLib (date) {
      if (date === undefined) {
        date = new Date()
      }
      const dtList = date.toLocaleString().split(' ')
      if (dtList.length !== 2) {
        return { error: '日時をテキスト化できませんでした。(1)' }
      }
      let year = ''
      let month = ''
      let day = ''
      if (dtList[0].indexOf('/') !== -1) {
        // モダンブラウザ
        const dateList = dtList[0].split('/')
        if (dateList.length !== 3 || dateList[0].length !== 4) {
          return { error: '日時をテキスト化できませんでした。(2)' }
        }
        year = dateList[0]
        month = (dateList[1].length === 1) ? '0' + dateList[1] : dateList[1]
        day = (dateList[2].length === 1) ? '0' + dateList[2] : dateList[2]
      } else if (dtList[0].indexOf('年') !== -1 && dtList[0].indexOf('月') !== -1 && dtList[0].indexOf('日') !== -1) {
        // IE対応
        const tempY = dtList[0].split('年')
        year = tempY[0]
        const tempM = tempY[1].split('月')
        month = (tempM[0].length === 1) ? '0' + tempM[0] : tempM[0]
        const tempD = tempM[1].split('日')
        day = (tempD[0].length === 1) ? '0' + tempD[0] : tempD[0]
      } else {
        return { error: '日時をテキスト化できませんでした。(3)' }
      }
      const timeList = dtList[1].split(':')
      if (timeList.length !== 3) {
        return { error: '日時をテキスト化できませんでした。(4)' }
      }
      const hour = (timeList[0].length === 1) ? '0' + timeList[0] : timeList[0]
      const minute = (timeList[1].length === 1) ? '0' + timeList[1] : timeList[1]
      const second = (timeList[2].length === 1) ? '0' + timeList[2] : timeList[2]
      return { result: { year: year, month: month, day: day, hour: hour, minute: minute, second: second } }
    },
    /**
     * [TBC]日時のテキスト化(YYYY/MM/DD-hh:mm:ss)
     * @param {Date} date Date型オブジェクト
     * @return {String} YYYY/MM/DD/-hh:mm:ss
     */
    miiafwlibs_dateTimeString (date) {
      if (date === undefined) {
        date = new Date()
      }
      const obj = this.miiafwlibs_dateTimeStringLib(date)
      if (Object.prototype.hasOwnProperty.call(obj, 'error')) {
        return obj.error
      }
      return obj.result.year + '/' + obj.result.month + '/' + obj.result.day + '-' + obj.result.hour + ':' + obj.result.minute + ':' + obj.result.second
    },
    /**
     * [TBC]日付のテキスト化(YYYY/MM/DD)
     * @param {Date} date Date型オブジェクト
     * @return {String} YYYY/MM/DD/
     */
    miiafwlibs_dateString (date) {
      if (date === undefined) {
        date = new Date()
      }
      const obj = this.miiafwlibs_dateTimeStringLib(date)
      if (Object.prototype.hasOwnProperty.call(obj, 'error')) {
        return obj.error
      }
      return obj.result.year + '/' + obj.result.month + '/' + obj.result.day
    },
    /**
     * [TBC]日時のテキスト化。数字のみ(YYYYMMDDhhmmss)。
     * @param {Date} date Date型オブジェクト
     * @return {String} YYYYMMDDhhmmss
     */
    miiafwlibs_dateTimeStringForUrl (date) {
      if (date === undefined) {
        date = new Date()
      }
      const obj = this.ingLib(date)
      if (Object.prototype.hasOwnProperty.call(obj, 'error')) {
        return obj.error
      }
      return obj.result.year + obj.result.month + obj.result.day + obj.result.hour + obj.result.minute + obj.result.second
    },
    /**
     * [TBC]コード（CCYYMMDD、CC:和暦、YY:年（和暦））から和暦と西暦を取得する。
     * eg. 95020411 -> {kanji: 令和2年4月11日, western: 20200411}
     * @param {String} code CCYYMMDD形式の文字列
     * @return {Object} {kanji: 和暦, western: 西暦} 和暦：和暦YY年MM月DD日、西暦：YYYYMMDD
     */
    miiafwlibs_codeToKanji (code) {
      if (code.length !== 8) return { kanji: '', western: '', message: `文字数が不正です。(${String(code.length)})` }
      const meijiCode = '91'
      const taishoCode = '92'
      const showaCode = '93'
      const heiseiCode = '94'
      const reiwaCode = '95'
      const nengoCode = code.slice(0, 2)
      let warekiNengo = ''
      let westernYear = ''
      const year = parseInt(code.slice(2, 4), 10)
      if (year.isNaN) return { kanji: '', western: '', message: `年の設定が不正です。(${code.slice(2, 4)})` }
      if (nengoCode === meijiCode) {
        warekiNengo = '明治'
        westernYear = 1868 + year - 1
      } else if (nengoCode === taishoCode) {
        warekiNengo = '大正'
        westernYear = 1912 + year - 1
      } else if (nengoCode === showaCode) {
        warekiNengo = '昭和'
        westernYear = 1926 + year - 1
      } else if (nengoCode === heiseiCode) {
        warekiNengo = '平成'
        westernYear = 1989 + year - 1
      } else if (nengoCode === reiwaCode) {
        warekiNengo = '令和'
        westernYear = 2019 + year - 1
      } else {
        return { kanji: '', western: '' }
      }
      const month = parseInt(code.slice(4, 6), 10)
      if (month.isNaN) return { kanji: '', western: '', message: `月の設定が不正です。(${code.slice(4, 6)})` }
      const day = parseInt(code.slice(6, 8), 10)
      if (day.isNaN) return { kanji: '', western: '', message: `日の設定が不正です。(${code.slice(6, 8)})` }
      let strYear = ''
      if (year === 1) {
        strYear = '元'
      } else if (year < 10) {
        strYear = ' ' + year.toString()
      } else {
        strYear = year.toString()
      }
      const strMonth = month < 10 ? ' ' + month.toString() : month.toString()
      const strDay = day < 10 ? ' ' + day.toString() : day.toString()
      return {
        kanji: warekiNengo + strYear + '年' + strMonth + '月' + strDay + '日',
        western: westernYear.toString() + code.slice(4, 8)
      }
    },
    // 西暦と和暦変換
    /**
     * [TBC]西暦を和暦に変換する。
     * @param {Date|String} argDate Date型オブジェクトか、YYYYMMDD形式の文字列か、YYYY/MM/DD形式の文字列（明治以降である必要あり）
     * @return {Object} {kanji: 和暦, code: コード} 和暦：和暦2年4月11日など、コード: CCYYMMDD（CCは和暦コード）
     */
    miiafwlibs_japaneseCalender (argDate) {
      const meijiCode = '91'
      const taishoCode = '92'
      const showaCode = '93'
      const heiseiCode = '94'
      const reiwaCode = '95'
      const meijiStartDate = new Date('1868-01-25T00:00:00+09:00')
      const taishoStartDate = new Date('1912-07-30T00:00:00+09:00')
      const showaStartDate = new Date('1926-12-25T00:00:00+09:00')
      const heiseiStartDate = new Date('1989-01-08T00:00:00+09:00')
      const reiwaStartDate = new Date('2019-05-01T00:00:00+09:00')
      let date = new Date()
      if (argDate === undefined) {
        // 処理なし
      } else if (Object.prototype.toString.call(argDate) === '[object Date]') {
        date = argDate
      } else if (typeof argDate === 'string' && argDate.length === 8 && !parseInt(argDate.slice(0, 4), 10).isNaN && !parseInt(argDate.slice(4, 6), 10).isNaN && !parseInt(argDate.slice(6, 8), 10).isNaN) {
        date = new Date(`${argDate.slice(0, 4)}-${argDate.slice(4, 6)}-${argDate.slice(6, 8)}T00:00:00+09:00`)
      } else if (typeof argDate === 'string' && argDate.length === 10 && !parseInt(argDate.slice(0, 4), 10).isNaN && !parseInt(argDate.slice(5, 7), 10).isNaN && !parseInt(argDate.slice(8, 10), 10).isNaN) {
        date = new Date(`${argDate.slice(0, 4)}-${argDate.slice(5, 7)}-${argDate.slice(8, 10)}T00:00:00+09:00`)
      } else {
        throw new Error(`引数が不正です。(${argDate})`)
      }
      var yearValue = ''
      if (date.getTime() >= reiwaStartDate.getTime()) {
        yearValue = date.getFullYear() - reiwaStartDate.getFullYear()
        return {
          kanji: '令和' + (yearValue === 0 ? '元' : (yearValue + 1).toString()) + '年' +
            ((date.getMonth() + 1) < 10 ? ' ' + (date.getMonth() + 1) : (date.getMonth() + 1)).toString() + '月' +
            (date.getDate() < 10 ? ' ' + date.getDate() : date.getDate()).toString() + '日',
          code: reiwaCode + (yearValue + 1).toString() +
            ((date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)).toString() +
            (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()).toString()
        }
      } else if (date.getTime() >= heiseiStartDate.getTime()) {
        yearValue = date.getFullYear() - heiseiStartDate.getFullYear()
        return {
          kanji: '平成' + (yearValue === 0 ? '元' : (yearValue + 1).toString()) + '年' +
            ((date.getMonth() + 1) < 10 ? ' ' + (date.getMonth() + 1) : (date.getMonth() + 1)).toString() + '月' +
            (date.getDate() < 10 ? ' ' + date.getDate() : date.getDate()).toString() + '日',
          code: heiseiCode + (yearValue + 1).toString() +
            ((date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)).toString() +
            (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()).toString()
        }
      } else if (date.getTime() >= showaStartDate.getTime()) {
        yearValue = date.getFullYear() - showaStartDate.getFullYear()
        return {
          kanji: '昭和' + (yearValue === 0 ? '元' : (yearValue + 1).toString()) + '年' +
            ((date.getMonth() + 1) < 10 ? ' ' + (date.getMonth() + 1) : (date.getMonth() + 1)).toString() + '月' +
            (date.getDate() < 10 ? ' ' + date.getDate() : date.getDate()).toString() + '日',
          code: showaCode + (yearValue + 1).toString() +
            ((date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)).toString() +
            (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()).toString()
        }
      } else if (date.getTime() >= taishoStartDate.getTime()) {
        yearValue = date.getFullYear() - taishoStartDate.getFullYear()
        return {
          kanji: '大正' + (yearValue === 0 ? '元' : (yearValue + 1).toString()) + '年' +
            ((date.getMonth() + 1) < 10 ? ' ' + (date.getMonth() + 1) : (date.getMonth() + 1)).toString() + '月' +
            (date.getDate() < 10 ? ' ' + date.getDate() : date.getDate()).toString() + '日',
          code: taishoCode + (yearValue + 1).toString() +
            ((date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)).toString() +
            (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()).toString()
        }
      } else if (date.getTime() >= meijiStartDate.getTime()) {
        yearValue = date.getFullYear() - meijiStartDate.getFullYear()
        return {
          kanji: '明治' + (yearValue === 0 ? '元' : (yearValue + 1).toString()) + '年' +
            ((date.getMonth() + 1) < 10 ? ' ' + (date.getMonth() + 1) : (date.getMonth() + 1)).toString() + '月' +
            (date.getDate() < 10 ? ' ' + date.getDate() : date.getDate()).toString() + '日',
          code: meijiCode + (yearValue + 1).toString() +
            ((date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)).toString() +
            (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()).toString()
        }
      } else {
        throw new Error('明治以前の日付が入力されました。')
      }
    },
    /**
     * [TBC]整数の乱数を作成
     * @param {Integer} max 乱数の範囲(eg. 3を入力すると0, 1, 2のうちどれかがランダムに返ってくる)
     * @return {Number} 0以上(len-1)以下の整数のうちどれか
     */
    miiafwlibs_rand (max) {
      return Math.floor(Math.random() * Math.floor(max))
    },
    /**
     * [TBC]ランダム文字列の作成
     * @param {Integer} len 文字列の長さ
     * @return {String} 小文字(a-z)大文字(A-Z)数字(0-9)からなる長さlenの文字列
     */
    miiafwlibs_randString (len) {
      // 生成する文字列に含める文字セット
      const c = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
      const cl = c.length
      let r = ''
      for (var i = 0; i < len; i++) {
        r += c[Math.floor(Math.random() * cl)]
      }
      return r
    },
    /**
     * [TBC]StringからBase64へ変換する
     * @param {String} text Base64で使用できる文字で構成される文字列
     * @return {Base64} Base64にエンコードされた文字列
     */
    miiafwlibs_toBase64 (text) {
      return window.btoa(unescape(encodeURIComponent(text)))
    },
    /**
     * [TBC]Base64からStringへ変換する
     * @param {Base64} code Base64にエンコードされた文字列
     * @return {String} 文字列
     */
    miiafwlibs_toText (code) {
      return decodeURIComponent(escape(window.atob(code)))
    },
    // String → Boolean変換
    miiafwlibs_toBoolean (text) {
      return text.toLowerCase() === 'true'
    },
    // バイナリ文字列をバイナリデータ(ArrayBuffer)に変換(例: '\xe3\x81\x82' → 0xE3, 0x81, 0x82)
    miiafwlibs_stringToArrayBuffer (str) {
      // Uint16Arrayを使用するとCPU依存で結果が異なるため、Uint8Arrayを使用する。
      return (new Uint8Array([].map.call(str, (c) => {
        return c.charCodeAt(0)
      }))).buffer // 戻り値はArrayBuffer型になる。
    },
    /**
     * ロード中表示/ロード中表示解除
     * @param {Boolean} isLanding trueならロード中を表示にし、falseなら解除する。
     * @param {String} message ロード中に文字を表示する。デフォルトは「処理中」。
     * @return {} 戻り値なし
     */
    miiafwlibs_setLoadingView (isLanding, message = '処理中') {
      if (isLanding) {
        this.$store.commit('miiaFwStore/enableLoadingView', message)
      } else {
        this.$store.commit('miiaFwStore/disableLoadingView')
      }
    },
    /**
     * [TBC]アラートを出力する。
     * @param {String} message アラートに表示する文字
     * @param {function} [callback = () => {}] アラートを閉じた時に呼び出される関数。
     * @return {} 戻り値なし
     */
    miiafwlibs_alert (message, callback) {
      if (callback === undefined) { callback = () => {} }
      const btnParams = [{ label: '確認', kind: 'primary', func: callback }]
      this.miiafwlibs_customBtnDialog('<p style="text-align: left;">' + message + '</p>', this.$sysName, btnParams)
    },
    /**
     * [TBC]確認メッセージ出力
     * @param {message} message 確認メッセージ
     * @param {function} okcallback 確認を選択したときに呼び出される関数
     * @param {function} [cancelCallback = () => {}] 閉じるを選択したときに呼び出される関数
     * @return {} 戻り値なし
     */
    miiafwlibs_confirm (message, okCallback, cancelCallback) {
      if (cancelCallback === undefined) { cancelCallback = () => {} }
      const btnParams = [
        {
          label: '閉じる',
          kind: 'secondary',
          func: cancelCallback
        },
        {
          label: '確認',
          kind: 'info',
          func: okCallback
        }
      ]
      this.miiafwlibs_customBtnDialog('<p style="text-align: left;">' + message + '</p>', this.$sysName, btnParams)
    },
    /**
     * 任意の数のボタンを持つダイアログ
     * 特にダイアログのカスタマイズを行わないのであれば、miiafwlibs_alertやmiiafwlibs_comfirmを使うと良い。
     * @param {String} message htmlでマークアップされたメッセージ eg. '<p style="text-align: left;">' + message + '</p>'
     * @param {String} title ダイアログのタイトル
     * @param {obj} btnParams オブジェクトのリスト。ボタンの数だけ存在する。メンバーはlabel: ボタンに表示する文章、kind: ボタンのカラー、func:押した時に実行される関数。ボタンのカラーをprimary, secondary, success, danger, warning, info, light, darkから選択する。ボタンのカラーの指定がない場合はprimaryになる。
     * @param {SS} styles 不明
     */
    miiafwlibs_customBtnDialog (message, title, btnParams, styles = []) {
      const btnClassDict = {
        primary: 'btn-primary',
        secondary: 'btn-secondary',
        success: 'btn-success',
        danger: 'btn-danger btn-primary', // 閉じるにフォーカスが当たるようにする。
        warning: 'btn-warning',
        info: 'btn-info',
        light: 'btn-light',
        dark: 'btn-dark'
      }
      if (btnParams instanceof Array) {
        const buttons = {}
        for (let i = 0; i < btnParams.length; i++) {
          if (typeof btnParams[i] === 'object' && Object.prototype.hasOwnProperty.call(btnParams[i], 'label')) {
            let kind = btnClassDict.primary
            if (Object.prototype.hasOwnProperty.call(btnParams[i], 'kind') && Object.prototype.hasOwnProperty.call(btnClassDict, btnParams[i].kind)) {
              kind = btnClassDict[btnParams[i].kind]
            }
            buttons[kind + '-' + i] = {
              label: btnParams[i].label,
              className: kind
            }
            if (Object.prototype.hasOwnProperty.call(btnParams[i], 'func') && typeof btnParams[i].func === 'function') {
              buttons[kind + '-' + i].callback = btnParams[i].func
            } else {
              buttons[kind + '-' + i].callback = () => {}
            }
          } else {
            console.error('ボタンパラメータが不正です。')
            console.error(btnParams[i])
          }
        }
        if (Object.keys(buttons).length > 0) {
          const dialog = bootbox.dialog({
            message: message,
            title: title,
            buttons: buttons,
            closeButton: false
          })
          if (dialog !== undefined) {
            dialog.find('.modal-title')[0].style.cssText = 'margin: 0 auto;'
            for (const elm of styles) {
              if (typeof elm === 'object' && Object.prototype.hasOwnProperty.call(elm, 'selector') && Object.prototype.hasOwnProperty.call(elm, 'style')) {
                dialog.find(elm.selector)[0].style.cssText = elm.style
              }
            }
          }
          return dialog
        }
      } else {
        console.error('ボタンパラメータの型はオブジェクトのリストにしてください。')
      }
    },
    /**
     * プロンプトダイアログ（入力ダイアログ）を表示する。
     * @param {String} message プロンプトダイアログに表示するメッセージ
     * @param {String} inputType 入力するデータの型
     * @param {function} okCallBack 入力に成功した際に行う動作。入力された値が関数の引数として入力される。
     * @param {function} cancelCallBack 入力に失敗またはキャンセルした際に行う動作
     * @param {String} size ダイアログボックスの横幅。'small'、'large', 'extra-Large'から選択。
     * @result {} 戻り値なし。
     */
    miiafwlibs_pronptDialog (message, inputType, okCallBack, cancelCallback, size = 'small') {
      bootbox.prompt({
        size: size,
        inputType: inputType,
        title: message,
        callback: (result) => {
          if (result === null) {
            cancelCallback()
          } else {
            okCallBack(result)
          }
        }
      })
    },
    /**
     * 帳票印刷コンテンツの要素(1頁分)作成
     * @param {String} formFileUrl フォームファイルのパス
     * @param {Object} params 帳票定義体に入力するパラメータ
     * @return {} 不明
     */
    miiafwlibs_createPrintContentsElm (formFileUrl, params) {
      // パラメータを帳票定義体に適用する。
      const applyParam = (data, params) => {
        let ret = data
        // デフォルトでは最初の一致だけ、一致するもの全てを抽出するにはglobalフラグを有効にする。
        // iは大文字小文字の違いを無視
        const re = /@\{[^}]+\}/gi
        const elms = ret.match(re)
        Object.keys(elms).forEach((key, index) => {
          const value = elms[key]
          const elm = value.match(/@\{(.+)\}/)[1]
          if (Object.prototype.hasOwnProperty.call(params, elm)) {
            // ターゲット文字列を置換
            ret = ret.replace(value, params[elm])
          } else {
            ret = ret.replace(value, '')
          }
        })
        return ret
      }
      return new Promise((resolve, reject) => {
        // 非同期処理での「window.open()」はポップアップブロックされる。
        this.$axios.get(formFileUrl).then((response) => {
          const ret = applyParam(response.data, params)
          resolve(ret)
        }).catch((error) => {
          reject({ message: `Status Code: ${error.response.status}, Message: ${error.response.statusText}` })
        })
      })
    },
    /**
     * 帳票印刷コンテンツ作成
     */
    miiafwlibs_createPrintContents (data, inProcessData) {
      const pageBreak = '<div class="new-page"></div>'
      if (inProcessData === undefined) {
        inProcessData = ''
      } else {
        if (data.length > 0) {
          inProcessData += pageBreak
        }
      }
      return new Promise((resolve, reject) => {
        if (data.length > 0) {
          const firstElement = data.shift()
          this.miiafwlibs_createPrintContentsElm(firstElement.path, firstElement.params).then((result) => {
            this.miiafwlibs_createPrintContents(data, inProcessData + result).then((reprocessedResult) => {
              resolve(reprocessedResult)
            }).catch((reprocessedError) => {
              reject(reprocessedError)
            })
          }).catch((error) => {
            reject(error)
          })
        } else {
          resolve(inProcessData)
        }
      })
    },
    // 帳票印刷
    miiafwlibs_printForm (data, title) {
      if (title === undefined) {
        title = '印刷ページ'
      }
      const sub = window.open()
      const prefix =
      '<!DOCTYPE html>' +
      '<html lang="ja">' +
        '<head>' +
          '<meta charset="UTF-8">' +
          `<title>${title}</title>` +
          '<style>div.new-page { page-break-before: always; }</style>' +
        '</head>' +
        '<body>'
      // scriptタグ内でscript閉じタグを記述できないので分割
      // ただちにclose()すると印刷できない場合がある。
      // const cmd1 = '<script>window.print();setTimeout(window.close, 500);<'
      // const cmd1 = '<script>window.print();alert("印刷実行後、OKボタンをクリックしてください。\\n(印刷画面が閉じます。)");close()<'
      const cmd1 = `<script>
                      (function() {
                        const mediaPrint = window.matchMedia('print');
                        mediaPrint.addListener(() => {
                          if (mediaPrint.matches) {
                            // 印刷前処理
                          } else {
                            // 印刷後処理
                            window.close();
                          }
                        });
                        window.print();
                      }());<`
      const cmd2 = '/script>'
      return new Promise((resolve, reject) => {
        this.miiafwlibs_createPrintContents(data).then((result) => {
          sub.document.write(prefix + result + cmd1 + cmd2 + '</body></html>')
          resolve('印刷ダイアログが閉じられました。')
        }).catch((error) => {
          reject(error)
        })
      })
    },
    miiafwlibs_strIns (str, idx, val) {
      const ret = str.slice(0, idx) + val + str.slice(idx)
      return ret
    },
    // XMLHttpRequestベースのWEB APIコール
    // responseTypeは、'arraybuffer', 'blob', 'document', 'json', 'text'の何れか
    // ブラウザが必要に応じてAccept-Encodingヘッダーを自動的に追加するので、DOM / JSレベルでこれを行う必要はない。
    // というか、XMLHttpRequestでHTTPヘッダ: Accept-Encodingを更新できない。(unsafe)
    // HTTPヘッダには日本語は使えない。
    miiafwlibs_webApiCall (url, method, headers, data, responseType, timeout) {
      if (timeout === undefined) {
        timeout = 1000 * 60 // デフォルトは1分
      }
      return new Promise((resolve, reject) => {
        if (responseType.toLowerCase() !== 'arraybuffer' &&
          responseType.toLowerCase() !== 'blob' &&
          responseType.toLowerCase() !== 'document' &&
          responseType.toLowerCase() !== 'json' &&
          responseType.toLowerCase() !== 'text') {
          reject({ message: 'Error: 不正なResponse Typeが指定されました。Response Type: ' + responseType })
        }
        const xhr = new XMLHttpRequest()
        // レスポンス受信が成功した時のハンドラ
        xhr.onload = () => {
          if (xhr.readyState === 4 && xhr.status === 200) {
            resolve(xhr.response, xhr.getResponseHeader('Content-Type').split(';')[0])
          } else {
            reject({ message: 'Error: サーバエラーを検出しました。Status Code: ' + xhr.status })
          }
        }
        // レスポンス受信が失敗した時のハンドラ
        xhr.onerror = () => {
          reject({ message: 'Error: データ受信に失敗しました。XMLHttpRequest Status: ' + xhr.status })
        }
        // 各HTTPメソッド毎の処理
        if (method.toLowerCase() === 'get') {
          let qs = url
          if (data !== null) {
            qs += '?'
            Object.keys(data).forEach((key) => {
              qs += key + '=' + data[key] + '&'
            })
            qs = qs.slice(0, -1) // 最後の「&」を削除
          }
          xhr.open('GET', qs, true)
          xhr.responseType = responseType.toLowerCase()
          Object.keys(headers).forEach((key) => {
            xhr.setRequestHeader(key, headers[key])
          })
          xhr.send(null)
        } else if (method.toLowerCase() === 'post') {
          xhr.open('POST', url, true)
          xhr.responseType = responseType.toLowerCase()
          xhr.setRequestHeader('Content-type', 'application/json')
          Object.keys(headers).forEach((key) => {
            xhr.setRequestHeader(key, headers[key])
          })
          xhr.send(JSON.stringify(data))
        } else if (method.toLowerCase() === 'head') {
          xhr.open('HEAD', url, true)
          xhr.responseType = responseType.toLowerCase()
          Object.keys(headers).forEach((key) => {
            xhr.setRequestHeader(key, headers[key])
          })
          xhr.send(null)
        } else if (method.toLowerCase() === 'put') {
          xhr.open('PUT', url, true)
          xhr.responseType = responseType.toLowerCase()
          Object.keys(headers).forEach((key) => {
            xhr.setRequestHeader(key, headers[key])
          })
          // xhr.overrideMimeType(data.type)
          xhr.send(data)
        } else if (method.toLowerCase() === 'delete') {
          xhr.open('DELETE', url, true)
          xhr.responseType = responseType.toLowerCase()
          Object.keys(headers).forEach((key) => {
            xhr.setRequestHeader(key, headers[key])
          })
          xhr.send(null)
        } else {
          reject({ message: 'Error: 不正なHTTPメソッドが指定されました。HTTP Method: ' + method })
        }
        // 受信タイムアウト処理
        setTimeout(() => {
          // タイムアウト時間になってもまだUNSENTまたはOPENEDだったらabortする。
          // UNSENT: 0 / OPENED: 0 / LOADING: 200 / DONE: 200
          if (xhr.status !== 200) {
            xhr.abort()
            reject({ message: 'Error: レスポンスタイムアウトです。XMLHttpRequest Status: ' + xhr.status })
          }
        }, timeout)
      })
    },
    // ファイルダウンロード
    miiafwlibs_downloadFile (contests, name) {
      if (this.miiafwlibs_getBrowser() !== 'ie') {
        const link = document.createElement('a')
        link.href = contests
        link.download = name
        link.click()
      } else {
        // IE対応
        window.navigator.msSaveOrOpenBlob(contests, name)
      }
    },
    // CSV → JSON変換(ヘッダ行あり)
    miiafwlibs_csv2Json (csv, requiredKeys) {
      const ret = {}
      const array = []
      const lines = csv.split(/\r\n|\r|\n/)
      const head = lines.shift()
      const keys = head.split(/\t|,/)
      let maxKeyIndex = 0
      if (requiredKeys !== undefined && requiredKeys instanceof Array) {
        for (let k = 0; k < requiredKeys.length; k++) {
          const keyIndex = keys.indexOf(requiredKeys[k])
          if (keyIndex === -1) {
            ret.error = 'マスタCSVに必須カラム: ' + requiredKeys[k] + 'がありません。'
            return ret
          }
          if (maxKeyIndex < keyIndex) {
            maxKeyIndex = keyIndex
          }
        }
      }
      for (let i = 0; i < lines.length; i++) {
        if (lines[i] !== '') {
          const cols = lines[i].split(/\t|,/)
          if (cols.length < maxKeyIndex + 1) {
            ret.error = i + 2 + '行目の要素が不足しています。' // 0スタート且つヘッダ分を考慮して2を加算
            return ret
          }
          const line = {}
          for (let j = 0; j < cols.length; j++) {
            if (cols[j] !== '') {
              // 値が空ではない場合だけkey & Valueを追加する。
              if (keys[j].toLowerCase().endsWith('_f')) {
                // キー名のSuffixが「_f」の場合はBoolean型に変換する。
                line[keys[j]] = this.miiafwlibs_toBoolean(cols[j].toLowerCase())
              } else if (keys[j].toLowerCase().endsWith('_n')) {
                // [TODO] キー名のSuffixが「_n」の場合はNumber型に変換する。
                line[keys[j]] = cols[j]
              } else if (keys[j].toLowerCase().endsWith('_b')) {
                // [TODO] キー名のSuffixが「_b」の場合はBinaryに変換する。
                line[keys[j]] = cols[j]
              } else if (keys[j].toLowerCase().endsWith('_ss')) {
                // [TODO] キー名のSuffixが「_ss」の場合はString Setに変換する。
                line[keys[j]] = cols[j]
              } else if (keys[j].toLowerCase().endsWith('_ns')) {
                // [TODO] キー名のSuffixが「_ns」の場合はNumber Setに変換する。
                line[keys[j]] = cols[j]
              } else if (keys[j].toLowerCase().endsWith('_bs')) {
                // [TODO] キー名のSuffixが「_bs」の場合はBoolean Setに変換する。
                line[keys[j]] = cols[j]
              } else if (keys[j].toLowerCase().endsWith('_m')) {
                // [TODO] キー名のSuffixが「_m」の場合はMap型に変換する。
                line[keys[j]] = cols[j]
              } else if (keys[j].toLowerCase().endsWith('_l')) {
                // [TODO] キー名のSuffixが「_l」の場合はList型に変換する。
                line[keys[j]] = cols[j]
              } else {
                line[keys[j]] = cols[j]
              }
            }
          }
          array.push(line)
        } else {
          if (i < lines.length - 1) {
            // 最後の行以外の空行は許可しない。
            ret.error = i + 2 + '行目に空行があります。除去してください。' // 0スタート且つヘッダ分を考慮して2を加算
            return ret
          }
        }
      }
      ret.result = array
      return ret
    },
    // JSONデータのバリデーションチェック + カラム追加
    // チェックオブジェクト(checkObjs)の形式: [{ key: [Key名], pattern: [正規表現], isNotNull: [true or false] }, {...}]
    // keyは必須、patternとisNotNullは任意、keyだけ設定しても意味はないがエラーにはしない。
    miiafwlibs_validationCheck (checkObjs, json, callback = () => {}) {
      let lineNum = 1
      const stackTrace = []
      let isValid = true
      json.forEach((item) => {
        for (const checkObj of checkObjs) {
          if (Object.prototype.hasOwnProperty.call(checkObj, 'key')) {
            const key = checkObj.key
            if (Object.prototype.hasOwnProperty.call(checkObj, 'pattern')) {
              const pattern = checkObj.pattern
              // console.log('キー: ' + key + 'の値: ' + item[key] +  'をパターン: ' + pattern + "で確認します。")
              const regex = new RegExp(pattern)
              if (Object.prototype.hasOwnProperty.call(item, key) && !regex.test(item[key])) {
                stackTrace.push(lineNum + 1 + '行目の要素: ' + key + 'の値が不正です。セットされた値: ' + item[key] + '、チェックパターン: ' + pattern)
                isValid = false
              }
            }
            if (Object.prototype.hasOwnProperty.call(checkObj, 'isNotNull') && checkObj.isNotNull && !Object.prototype.hasOwnProperty.call(item, key)) {
              stackTrace.push(lineNum + 1 + '行目に必須項目: ' + key + '記載されていません。')
              isValid = false
            }
          } else {
            stackTrace.length = 0 // 意図的に配列サイズを0にすることで配列の全要素を削除
            stackTrace.push('バリデーションチェックオブジェクトの形式が不正です。')
            isValid = false
          }
        }
        if (isValid) {
          callback(item)
        }
        isValid = true
        lineNum += 1
      })
      return stackTrace
    },
    // QRコード(SVG)を生成する。(String型)
    miiafwlibs_makeQr (text, x, y, w, h, margin = 5) {
      const Qrcodesvg = require('qrcodesvg')
      const qrcode = new Qrcodesvg(text, w - margin * 2)
      const strQr = qrcode.generate()
      return this.miiafwlibs_strIns(strQr, strQr.indexOf('<svg ') + 5, 'x="' + (x + margin) + '" y="' + (y + margin) + '" ')
    },
    // エンコーディングと改行コードを変換する。
    miiafwlibs_toUnicodeAndLf (obj) {
      let array = new Uint8Array(obj)
      const ret = {}
      const Encoding = require('encoding-japanese')
      switch (Encoding.detect(array)) {
        case 'ASCII':
        case 'UTF8':
        case 'SJIS':
        case 'EUCJP':
          if (array[0].toString(16) === 'ef' && array[1].toString(16) === 'bb' && array[2].toString(16) === 'bf') {
            array = array.slice(3) // BOM除去
          }
          break
        case 'UTF16':
          array = new Uint16Array(obj) // UTF16と32は別の配列変換
          if (array[0].toString(16) === 'feff') {
            array = array.slice(1) // BOM除去
          }
          break
        case 'UTF32':
          array = new Uint32Array(obj) // UTF16と32は別の配列変換
          if (array[0].toString(16) === 'feff') {
            array = array.slice(1) // BOM除去
          }
          break
        default:
          ret.error = '対応していない文字コードです。検出した文字コード: ' + Encoding.detect(array)
          return ret
      }
      const tempArray = Encoding.convert(array, 'UNICODE', 'AUTO') // Unicodeへエンコーディング変換
      const buf = Encoding.codeToString(tempArray) // 文字列へ変換
      ret.result = buf.replace(/\r\n|\r/g, '\n') // 改行コードをLFに変換
      return ret
    },
    // 共有テンポラリ情報の管理ユーティリティ(作成&上書き)
    miiafwlibs_tempDataSetItem (key, json) {
      if ((window.sessionStorage !== null) && ('sessionStorage' in window)) {
        try {
          sessionStorage.setItem(key, JSON.stringify(json))
        } catch (error) {
          console.error(error)
          return false
        }
        return true
      } else {
        console.error('セッションストレージを使用できません。')
        return false
      }
    },
    // 共有テンポラリ情報の管理ユーティリティ(取り出し)
    miiafwlibs_tempDataGetItem (key) {
      let ret = {}
      if ((window.sessionStorage !== null) && ('sessionStorage' in window)) {
        try {
          ret = JSON.parse(sessionStorage.getItem(key))
        } catch (error) {
          console.error(error)
          return null
        }
        return ret
      } else {
        console.error('セッションストレージを使用できません。')
        return null
      }
    },
    // 共有テンポラリ情報の管理ユーティリティ(キー一覧取得)
    miiafwlibs_tempDataList () {
      const ret = []
      if ((window.sessionStorage !== null) && ('sessionStorage' in window)) {
        try {
          for (let i = 1; i < sessionStorage.length; i++) {
            ret.push(sessionStorage.key(i))
          }
          return ret
        } catch (error) {
          console.error(error)
          return null
        }
      } else {
        console.error('セッションストレージを使用できません。')
        return null
      }
    },
    // 共有テンポラリ情報の管理ユーティリティ(削除)
    miiafwlibs_tempDataRemoveItem (key) {
      if ((window.sessionStorage !== null) && ('sessionStorage' in window)) {
        try {
          sessionStorage.removeItem(key)
          delete sessionStorage[key]
        } catch (error) {
          console.error(error)
          return false
        }
        return true
      } else {
        console.error('セッションストレージを使用できません。')
        return false
      }
    },
    // 共有テンポラリ情報の管理ユーティリティ(全削除)
    miiafwlibs_tempDataClear () {
      if ((window.sessionStorage !== null) && ('sessionStorage' in window)) {
        try {
          sessionStorage.clear()
        } catch (error) {
          console.error(error)
          return false
        }
        return true
      } else {
        console.error('セッションストレージを使用できません。')
        return false
      }
    },
    // セッション情報の取得(キー指定)
    miiafwlibs_getSessionInfo (key) {
      let result = ''
      const sessionInfo = this.miiafwlibs_getAllSessionInfo()
      if (Object.prototype.hasOwnProperty.call(sessionInfo, key)) {
        result = sessionInfo[key]
      }
      return result
    },
    // セッション情報の取得(全情報をJSON形式で取得)
    miiafwlibs_getAllSessionInfo () {
      const result = []
      const allCookies = document.cookie
      if (allCookies !== '') {
        const cookies = allCookies.split('; ')
        for (let i = 0; i < cookies.length; i++) {
          const cookie = cookies[i].split('=')
          result[cookie[0]] = decodeURIComponent(cookie[1])
        }
      }
      return result
    },
    // セッション情報の削除
    miiafwlibs_RemoveSessionInfo (keys) {
      let cookieScope = ''
      if (this.$authorization.accessibleDomain) {
        cookieScope += '; Domain=' + this.$authorization.accessibleDomain
      }
      if (this.$authorization.accessiblePath) {
        cookieScope += '; Path=' + this.$authorization.accessiblePath
      }
      keys.forEach((key) => {
        document.cookie = key + '=; Max-Age=0' + cookieScope // Pathを指定してCookieを設定した場合は削除時もPathを指定する必要がある。
      })
    },
    // ArrayBuffer から文字列への変換
    // 文字列が長すぎる場合、RangeError: Maximum call stack size exceeded.が発生するので1024Byte毎に分割して処理する。
    miiafwlibs_bufferToJson (buf) {
      let obj = {}
      try {
        const strRes = new TextDecoder().decode(buf)
        obj = JSON.parse(strRes)
      } catch (error) {
        console.error(error)
        obj = {}
      }
      return obj
    },
    /**
     * [TBC]ブラウザを確認する。
     * @return {String} 使用しているブラウザの名前を出力する(ie, edge, chrome, safari, firefox, opera, unknownのうちのいずれか)。
     */
    miiafwlibs_getBrowser () {
      const userAgent = window.navigator.userAgent.toLowerCase()
      if (userAgent.indexOf('msie') !== -1 || userAgent.indexOf('trident') !== -1) {
        return 'ie'
      } else if (userAgent.indexOf('edge') !== -1) {
        return 'edge'
      } else if (userAgent.indexOf('chrome') !== -1) {
        return 'chrome'
      } else if (userAgent.indexOf('safari') !== -1) {
        return 'safari'
      } else if (userAgent.indexOf('firefox') !== -1) {
        return 'firefox'
      } else if (userAgent.indexOf('opera') !== -1) {
        return 'opera'
      } else {
        return 'unknown'
      }
    },
    /**
     * [TBC]オブジェクトにある言語設定の更新する
     * @param {String} lang 更新する言語(eg. ja, en)
     * @return {} 返り値なし
     */
    miiafwlibs_updateLang (lang) {
      this.$lang = lang
      this.$i18n.locale = this.$lang // 言語設定
    },
    /**
     * [TBC]数値をコンマ区切りの文字列に変換する。
     * eg. 1000 -> 1,000; 234.5678 -> 234.567,8
     * @param {Number}  num 数値(eg. 1000)
     * @return {string} コンマ区切りの文字列(eg. 1,000)
     */
    miiafwlibs_addComma (num) {
      if (typeof num === 'number') {
        return String(num).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      // } else if (typeof num === 'string' && parseInt(num, 10) !== NaN) {
      } else if (!isNaN(num)) {
        num.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      } else {
        return 'Not a Number!'
      }
    }
  }
}
</script>
